var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _g, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _g2, _path240, _path241, _path242, _g3, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoCarImg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 188,
    viewBox: "0 0 251 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215.622 57.4673C215.622 57.4673 197.181 22.5762 158.684 9.05031C120.188 -4.47556 102.399 7.33481 82.6733 20.1186C67.1489 30.1797 54.9925 44.7506 42.2751 57.6491C30.6313 69.4589 13.5609 78.613 8.17268 94.967C1.35964 115.651 16.7938 138.005 35.1097 150.014C60.669 166.772 85.4496 156.518 112.144 152.579C112.194 152.572 112.245 152.565 112.295 152.557C116.154 151.998 120.056 151.616 124.002 151.625C155.001 151.691 177.25 173.58 199.831 151.045C222.413 128.509 226.008 84.6239 215.622 57.4673Z",
    fill: "#EDFBF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M215.622 57.4673C215.622 57.4673 197.181 22.5762 158.684 9.05031C120.188 -4.47556 102.399 7.33481 82.6733 20.1186C67.1489 30.1797 54.9925 44.7506 42.2751 57.6491C30.6313 69.4589 13.5609 78.613 8.17268 94.967C1.35964 115.651 16.7938 138.005 35.1097 150.014C60.669 166.772 85.4496 156.518 112.144 152.579C112.194 152.572 112.245 152.565 112.295 152.557C116.154 151.998 120.056 151.616 124.002 151.625C155.001 151.691 177.25 173.58 199.831 151.045C222.413 128.509 226.008 84.6239 215.622 57.4673Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M203.138 51.1652C201.277 50.1504 200.431 50.9962 199.755 50.1504C199.078 49.3046 201.615 47.1056 196.541 44.9067C196.541 44.9067 196.203 40.1709 189.268 40.0014C182.333 39.8318 184.194 44.7377 182.333 45.9214C180.473 47.1056 179.965 45.2445 178.105 46.4288C176.244 47.613 177.09 49.9809 175.567 50.3193C174.045 50.6578 172.015 48.7973 170.155 49.9809C168.294 51.1652 168.294 52.1799 167.448 52.1799C166.603 52.1799 164.911 51.5036 163.896 52.1799C162.882 52.8568 161.697 53.702 161.697 53.702H204.491C204.491 53.702 204.998 52.1799 203.138 51.1652Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7727 65.7225C96.9281 65.2617 96.5442 65.6456 96.2372 65.2617C95.9302 64.8779 97.0818 63.88 94.7786 62.8816C94.7786 62.8816 94.6248 60.7322 91.4775 60.6553C88.3296 60.5784 89.1743 62.8053 88.3296 63.3424C87.485 63.88 87.2549 63.0354 86.4103 63.5725C85.5656 64.1101 85.9495 65.1849 85.2587 65.3381C84.5678 65.4918 83.6463 64.6472 82.8016 65.1843C81.957 65.7219 81.957 66.1821 81.5731 66.1821C81.1892 66.1821 80.4215 65.8751 79.9607 66.1821C79.5 66.4891 78.9629 66.873 78.9629 66.873H98.3872C98.3867 66.8741 98.6173 66.1833 97.7727 65.7225Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.51 16.8144C112.348 16.1812 111.821 16.709 111.398 16.1812C110.976 15.6534 112.56 14.2805 109.392 12.9081C109.392 12.9081 109.181 9.95243 104.853 9.84641C100.524 9.74097 101.686 12.8026 100.524 13.5413C99.3625 14.2805 99.0462 13.119 97.8847 13.8582C96.7231 14.5974 97.2515 16.0752 96.3008 16.2866C95.3507 16.4981 94.0838 15.3366 92.9223 16.0758C91.7607 16.815 91.7607 17.4482 91.233 17.4482C90.7052 17.4482 89.6491 17.0258 89.0159 17.4482C88.3828 17.8705 87.6436 18.3982 87.6436 18.3982H114.354C114.354 18.3982 114.671 17.4482 113.51 16.8144Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4486 74.8945H33.6982V79.6816H38.4486V74.8945Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4883 77.793H28.5625V79.6826H30.4883V77.793Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M223.744 105.126H205.737V67.1348H206.939V63.2017H164.748V67.1348H166.21V123.636H155.142V2.41797H117.195V94.0892H103.321V83.9402H106.955V79.6494H76.6134V18.1498H78.577V14.932H41.749V18.1498H44.3901V79.7543H15.2839V123.812H0",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M156.653 1.0918H115.505V2.40769H156.653V1.0918Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3206 21.7256H47.6855V26.6874H52.3206V21.7256Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1184 21.7256H54.4834V26.6874H59.1184V21.7256Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9163 21.7256H61.2812V26.6874H65.9163V21.7256Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7141 21.7256H68.0791V26.6874H72.7141V21.7256Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3206 29.5918H47.6855V34.5536H52.3206V29.5918Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1184 29.5918H54.4834V34.5536H59.1184V29.5918Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9163 29.5918H61.2812V34.5536H65.9163V29.5918Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7141 29.5918H68.0791V34.5536H72.7141V29.5918Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3206 37.458H47.6855V42.4198H52.3206V37.458Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1184 37.458H54.4834V42.4198H59.1184V37.458Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9163 37.458H61.2812V42.4198H65.9163V37.458Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7141 37.458H68.0791V42.4198H72.7141V37.458Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3206 45.3242H47.6855V50.2855H52.3206V45.3242Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1184 45.3242H54.4834V50.2855H59.1184V45.3242Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9163 45.3242H61.2812V50.2855H65.9163V45.3242Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7141 45.3242H68.0791V50.2855H72.7141V45.3242Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3206 53.1904H47.6855V58.1522H52.3206V53.1904Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1184 53.1904H54.4834V58.1522H59.1184V53.1904Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9163 53.1904H61.2812V58.1522H65.9163V53.1904Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7141 53.1904H68.0791V58.1522H72.7141V53.1904Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3206 61.0566H47.6855V66.0185H52.3206V61.0566Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1184 61.0566H54.4834V66.0185H59.1184V61.0566Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9163 61.0566H61.2812V66.0185H65.9163V61.0566Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7141 61.0566H68.0791V66.0185H72.7141V61.0566Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3206 68.9229H47.6855V73.8847H52.3206V68.9229Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1184 68.9229H54.4834V73.8847H59.1184V68.9229Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9163 68.9229H61.2812V73.8847H65.9163V68.9229Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7141 68.9229H68.0791V73.8847H72.7141V68.9229Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3206 76.7891H47.6855V81.7509H52.3206V76.7891Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1184 76.7891H54.4834V81.7509H59.1184V76.7891Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9163 76.7891H61.2812V81.7509H65.9163V76.7891Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7141 76.7891H68.0791V81.7509H72.7141V76.7891Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3206 83.9834H47.6855V88.9452H52.3206V83.9834Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1184 83.9834H54.4834V88.9452H59.1184V83.9834Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9163 83.9834H61.2812V88.9452H65.9163V83.9834Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7141 83.9834H68.0791V88.9452H72.7141V83.9834Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3206 91.8496H47.6855V96.8114H52.3206V91.8496Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1184 91.8496H54.4834V96.8114H59.1184V91.8496Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9163 91.8496H61.2812V96.8114H65.9163V91.8496Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7141 91.8496H68.0791V96.8114H72.7141V91.8496Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3206 99.7158H47.6855V104.678H52.3206V99.7158Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1184 99.7158H54.4834V104.678H59.1184V99.7158Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9163 99.7158H61.2812V104.678H65.9163V99.7158Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7141 99.7158H68.0791V104.678H72.7141V99.7158Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3206 107.582H47.6855V112.544H52.3206V107.582Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1184 107.582H54.4834V112.544H59.1184V107.582Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9163 107.582H61.2812V112.544H65.9163V107.582Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7141 107.582H68.0791V112.544H72.7141V107.582Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3206 115.448H47.6855V120.41H52.3206V115.448Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1184 115.448H54.4834V120.41H59.1184V115.448Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9163 115.448H61.2812V120.41H65.9163V115.448Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7141 115.448H68.0791V120.41H72.7141V115.448Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3206 123.314H47.6855V128.276H52.3206V123.314Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1184 123.314H54.4834V128.276H59.1184V123.314Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9163 123.314H61.2812V128.276H65.9163V123.314Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7141 123.314H68.0791V128.276H72.7141V123.314Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3206 131.181H47.6855V136.142H52.3206V131.181Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1184 131.181H54.4834V136.142H59.1184V131.181Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9163 131.181H61.2812V136.142H65.9163V131.181Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7141 131.181H68.0791V136.142H72.7141V131.181Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3206 139.047H47.6855V144.009H52.3206V139.047Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1184 139.047H54.4834V144.009H59.1184V139.047Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9163 139.047H61.2812V144.009H65.9163V139.047Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7141 139.047H68.0791V144.009H72.7141V139.047Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8713 83.9834H74.2363V88.9452H78.8713V83.9834Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6692 83.9834H81.0342V88.9452H85.6692V83.9834Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M92.468 83.9834H87.833V88.9452H92.468V83.9834Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2659 83.9834H94.6309V88.9452H99.2659V83.9834Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8713 91.8496H74.2363V96.8114H78.8713V91.8496Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6692 91.8496H81.0342V96.8114H85.6692V91.8496Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M92.468 91.8496H87.833V96.8114H92.468V91.8496Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2659 91.8496H94.6309V96.8114H99.2659V91.8496Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8713 99.7158H74.2363V104.678H78.8713V99.7158Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6692 99.7158H81.0342V104.678H85.6692V99.7158Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M92.468 99.7158H87.833V104.678H92.468V99.7158Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2659 99.7158H94.6309V104.678H99.2659V99.7158Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8713 107.582H74.2363V112.544H78.8713V107.582Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6692 107.582H81.0342V112.544H85.6692V107.582Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M92.468 107.582H87.833V112.544H92.468V107.582Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2659 107.582H94.6309V112.544H99.2659V107.582Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8713 115.448H74.2363V120.41H78.8713V115.448Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6692 115.448H81.0342V120.41H85.6692V115.448Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M92.468 115.448H87.833V120.41H92.468V115.448Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2659 115.448H94.6309V120.41H99.2659V115.448Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8713 123.314H74.2363V128.276H78.8713V123.314Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6692 123.314H81.0342V128.276H85.6692V123.314Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M92.468 123.314H87.833V128.276H92.468V123.314Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2659 123.314H94.6309V128.276H99.2659V123.314Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8713 131.181H74.2363V136.142H78.8713V131.181Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6692 131.181H81.0342V136.142H85.6692V131.181Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M92.468 131.181H87.833V136.142H92.468V131.181Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2659 131.181H94.6309V136.142H99.2659V131.181Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8713 139.047H74.2363V144.009H78.8713V139.047Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6692 139.047H81.0342V144.009H85.6692V139.047Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M92.468 139.047H87.833V144.009H92.468V139.047Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2659 139.047H94.6309V144.009H99.2659V139.047Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3948 83.9834H20.7598V88.9452H25.3948V83.9834Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1926 83.9834H27.5576V88.9452H32.1926V83.9834Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9905 83.9834H34.3555V88.9452H38.9905V83.9834Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7883 83.9834H41.1533V88.9452H45.7883V83.9834Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3948 91.8496H20.7598V96.8114H25.3948V91.8496Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1926 91.8496H27.5576V96.8114H32.1926V91.8496Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9905 91.8496H34.3555V96.8114H38.9905V91.8496Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7883 91.8496H41.1533V96.8114H45.7883V91.8496Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3948 99.7158H20.7598V104.678H25.3948V99.7158Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1926 99.7158H27.5576V104.678H32.1926V99.7158Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9905 99.7158H34.3555V104.678H38.9905V99.7158Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7883 99.7158H41.1533V104.678H45.7883V99.7158Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3948 107.582H20.7598V112.544H25.3948V107.582Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1926 107.582H27.5576V112.544H32.1926V107.582Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9905 107.582H34.3555V112.544H38.9905V107.582Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7883 107.582H41.1533V112.544H45.7883V107.582Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3948 115.448H20.7598V120.41H25.3948V115.448Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1926 115.448H27.5576V120.41H32.1926V115.448Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9905 115.448H34.3555V120.41H38.9905V115.448Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7883 115.448H41.1533V120.41H45.7883V115.448Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3948 123.314H20.7598V128.276H25.3948V123.314Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1926 123.314H27.5576V128.276H32.1926V123.314Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9905 123.314H34.3555V128.276H38.9905V123.314Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7883 123.314H41.1533V128.276H45.7883V123.314Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3948 131.181H20.7598V136.142H25.3948V131.181Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1926 131.181H27.5576V136.142H32.1926V131.181Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9905 131.181H34.3555V136.142H38.9905V131.181Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7883 131.181H41.1533V136.142H45.7883V131.181Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3948 139.047H20.7598V144.009H25.3948V139.047Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1926 139.047H27.5576V144.009H32.1926V139.047Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9905 139.047H34.3555V144.009H38.9905V139.047Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7883 139.047H41.1533V144.009H45.7883V139.047Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M177.248 68.5645H172.613V73.5263H177.248V68.5645Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M184.046 68.5645H179.411V73.5263H184.046V68.5645Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M190.845 68.5645H186.21V73.5263H190.845V68.5645Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M197.643 68.5645H193.008V73.5263H197.643V68.5645Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M177.248 76.4307H172.613V81.3925H177.248V76.4307Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M184.046 76.4307H179.411V81.3925H184.046V76.4307Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M190.845 76.4307H186.21V81.3925H190.845V76.4307Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M197.643 76.4307H193.008V81.3925H197.643V76.4307Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M177.248 84.2969H172.613V89.2587H177.248V84.2969Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M184.046 84.2969H179.411V89.2587H184.046V84.2969Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M190.845 84.2969H186.21V89.2587H190.845V84.2969Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M197.643 84.2969H193.008V89.2587H197.643V84.2969Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M177.248 92.1631H172.613V97.1249H177.248V92.1631Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M184.046 92.1631H179.411V97.1249H184.046V92.1631Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M190.845 92.1631H186.21V97.1249H190.845V92.1631Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M197.643 92.1631H193.008V97.1249H197.643V92.1631Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M177.248 100.029H172.613V104.991H177.248V100.029Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M184.046 100.029H179.411V104.991H184.046V100.029Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M190.845 100.029H186.21V104.991H190.845V100.029Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M197.643 100.029H193.008V104.991H197.643V100.029Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M177.248 107.896H172.613V112.857H177.248V107.896Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M184.046 107.896H179.411V112.857H184.046V107.896Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M190.845 107.896H186.21V112.857H190.845V107.896Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M197.643 107.896H193.008V112.857H197.643V107.896Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M177.248 115.762H172.613V120.724H177.248V115.762Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M184.046 115.762H179.411V120.724H184.046V115.762Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M190.845 115.762H186.21V120.724H190.845V115.762Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M197.643 115.762H193.008V120.724H197.643V115.762Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M177.248 123.628H172.613V128.59H177.248V123.628Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M184.046 123.628H179.411V128.59H184.046V123.628Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M190.845 123.628H186.21V128.59H190.845V123.628Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M197.643 123.628H193.008V128.59H197.643V123.628Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M120.77 5.27734V149.014",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M125.366 5.27734V149.014",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M129.964 5.27734V149.014",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M134.561 5.27734V149.014",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M139.158 5.27734V149.014",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M143.755 5.27734V149.014",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M148.353 5.27734V149.014",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M152.949 5.27734V149.014",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M106.294 146.512H23.8711V151.16H106.294V146.512Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M230.895 146.512H156.882V151.16H230.895V146.512Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M149.966 146.328C149.966 146.328 158.046 147.127 162.141 152.136C162.141 152.136 166.467 146.334 174.238 146.453C176.492 143.735 177.849 140.245 177.85 136.437C177.853 127.764 170.825 120.73 162.151 120.728C153.478 120.725 146.444 127.753 146.441 136.427C146.44 140.186 147.761 143.638 149.963 146.342L149.966 146.328Z",
    fill: "#FFA726"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M149.966 146.328C149.966 146.328 158.046 147.127 162.141 152.136C162.141 152.136 166.467 146.334 174.238 146.453C176.492 143.735 177.849 140.245 177.85 136.437C177.853 127.764 170.825 120.73 162.151 120.728C153.478 120.725 146.444 127.753 146.441 136.427C146.44 140.186 147.761 143.638 149.963 146.342L149.966 146.328Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M161.874 121.835L161.601 162.338H162.965L161.874 121.835Z",
    fill: "#263238"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M162.283 150.61C162.283 150.61 165.01 145.7 169.919 144.2C169.919 144.2 164.737 145.428 162.146 149.655L162.283 150.61Z",
    fill: "#263238"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M162.283 136.699C162.283 136.699 165.01 131.79 169.919 130.29C169.919 130.29 164.737 131.517 162.146 135.745L162.283 136.699Z",
    fill: "#263238"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M162.283 143.654C162.283 143.654 165.01 138.745 169.919 137.245C169.919 137.245 164.737 138.472 162.146 142.7L162.283 143.654Z",
    fill: "#263238"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M161.879 140.245C161.879 140.245 159.247 135.336 154.51 133.836C154.51 133.836 159.51 135.063 162.01 139.291L161.879 140.245Z",
    fill: "#263238"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M161.879 147.064C161.879 147.064 159.247 142.154 154.51 140.654C154.51 140.654 159.51 141.882 162.01 146.11L161.879 147.064Z",
    fill: "#263238"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M188.021 143.257C188.021 143.257 197.65 144.21 202.53 150.179C202.53 150.179 207.686 143.264 216.947 143.406C219.634 140.166 221.251 136.007 221.252 131.47C221.256 121.133 212.879 112.751 202.543 112.747C192.206 112.744 183.824 121.12 183.82 131.457C183.819 135.937 185.393 140.05 188.018 143.273L188.021 143.257Z",
    fill: "#FFA726"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M188.021 143.257C188.021 143.257 197.65 144.21 202.53 150.179C202.53 150.179 207.686 143.264 216.947 143.406C219.634 140.166 221.251 136.007 221.252 131.47C221.256 121.133 212.879 112.751 202.543 112.747C192.206 112.744 183.824 121.12 183.82 131.457C183.819 135.937 185.393 140.05 188.018 143.273L188.021 143.257Z",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M202.212 114.067L201.887 162.338H203.512L202.212 114.067Z",
    fill: "#263238"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M202.7 148.36C202.7 148.36 205.95 142.509 211.801 140.722C211.801 140.722 205.626 142.184 202.537 147.222L202.7 148.36Z",
    fill: "#263238"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M202.7 131.783C202.7 131.783 205.95 125.932 211.801 124.144C211.801 124.144 205.626 125.606 202.537 130.644L202.7 131.783Z",
    fill: "#263238"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M202.7 140.072C202.7 140.072 205.95 134.221 211.801 132.433C211.801 132.433 205.626 133.895 202.537 138.933L202.7 140.072Z",
    fill: "#263238"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M202.217 136.008C202.217 136.008 199.081 130.157 193.436 128.369C193.436 128.369 199.395 129.832 202.375 134.871L202.217 136.008Z",
    fill: "#263238"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M202.217 144.135C202.217 144.135 199.081 138.284 193.436 136.496C193.436 136.496 199.395 137.959 202.375 142.997L202.217 144.135Z",
    fill: "#263238"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M226.78 148.832C226.78 148.832 233.596 149.507 237.05 153.732C237.05 153.732 240.7 148.837 247.255 148.937C249.157 146.645 250.302 143.7 250.303 140.488C250.305 133.171 244.376 127.238 237.059 127.235C229.742 127.233 223.809 133.162 223.807 140.479C223.805 143.65 224.92 146.562 226.778 148.843L226.78 148.832Z",
    fill: "#FFA726"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M226.78 148.832C226.78 148.832 233.596 149.507 237.05 153.732C237.05 153.732 240.7 148.837 247.255 148.937C249.157 146.645 250.302 143.7 250.303 140.488C250.305 133.171 244.376 127.238 237.059 127.235C229.742 127.233 223.809 133.162 223.807 140.479C223.805 143.65 224.92 146.562 226.778 148.843L226.78 148.832Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M236.825 128.17L236.595 162.338H237.745L236.825 128.17Z",
    fill: "#263238"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M237.17 152.444C237.17 152.444 239.471 148.302 243.613 147.037C243.613 147.037 239.241 148.072 237.056 151.639L237.17 152.444Z",
    fill: "#263238"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M237.17 140.71C237.17 140.71 239.471 136.568 243.613 135.303C243.613 135.303 239.241 136.338 237.056 139.905L237.17 140.71Z",
    fill: "#263238"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M237.17 146.577C237.17 146.577 239.471 142.436 243.613 141.17C243.613 141.17 239.241 142.205 237.056 145.772L237.17 146.577Z",
    fill: "#263238"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M236.829 143.701C236.829 143.701 234.609 139.559 230.612 138.294C230.612 138.294 234.831 139.329 236.94 142.896L236.829 143.701Z",
    fill: "#263238"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M236.829 149.453C236.829 149.453 234.609 145.311 230.612 144.046C230.612 144.046 234.831 145.082 236.94 148.648L236.829 149.453Z",
    fill: "#263238"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27125 146.328C9.27125 146.328 17.3507 147.127 21.4457 152.136C21.4457 152.136 25.772 146.334 33.5427 146.453C35.7976 143.735 37.1542 140.245 37.1554 136.437C37.1583 127.764 30.1298 120.73 21.4568 120.728C12.7838 120.725 5.74998 127.753 5.74707 136.427C5.74591 140.186 7.06646 143.638 9.26892 146.342L9.27125 146.328Z",
    fill: "#FFA726"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.27125 146.328C9.27125 146.328 17.3507 147.127 21.4457 152.136C21.4457 152.136 25.772 146.334 33.5427 146.453C35.7976 143.735 37.1542 140.245 37.1554 136.437C37.1583 127.764 30.1298 120.73 21.4568 120.728C12.7838 120.725 5.74998 127.753 5.74707 136.427C5.74591 140.186 7.06646 143.638 9.26892 146.342L9.27125 146.328Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1785 121.835L20.9053 162.338H22.2689L21.1785 121.835Z",
    fill: "#263238"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5875 150.61C21.5875 150.61 24.3148 145.7 29.2242 144.2C29.2242 144.2 24.0422 145.428 21.4512 149.655L21.5875 150.61Z",
    fill: "#263238"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5875 136.699C21.5875 136.699 24.3148 131.79 29.2242 130.29C29.2242 130.29 24.0422 131.517 21.4512 135.745L21.5875 136.699Z",
    fill: "#263238"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5875 143.654C21.5875 143.654 24.3148 138.745 29.2242 137.245C29.2242 137.245 24.0422 138.472 21.4512 142.7L21.5875 143.654Z",
    fill: "#263238"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1832 140.245C21.1832 140.245 18.5514 135.336 13.8145 133.836C13.8145 133.836 18.8147 135.063 21.3148 139.291L21.1832 140.245Z",
    fill: "#263238"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1832 147.064C21.1832 147.064 18.5514 142.154 13.8145 140.654C13.8145 140.654 18.8147 141.882 21.3148 146.11L21.1832 147.064Z",
    fill: "#263238"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3265 143.257C47.3265 143.257 56.9553 144.21 61.8356 150.179C61.8356 150.179 66.9914 143.264 76.2527 143.406C78.9398 140.166 80.5569 136.007 80.558 131.47C80.5615 121.133 72.185 112.751 61.8484 112.747C51.5118 112.744 43.1295 121.12 43.126 131.457C43.1242 135.937 44.6982 140.05 47.3235 143.273L47.3265 143.257Z",
    fill: "#FFA726"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M47.3265 143.257C47.3265 143.257 56.9553 144.21 61.8356 150.179C61.8356 150.179 66.9914 143.264 76.2527 143.406C78.9398 140.166 80.5569 136.007 80.558 131.47C80.5615 121.133 72.185 112.751 61.8484 112.747C51.5118 112.744 43.1295 121.12 43.126 131.457C43.1242 135.937 44.6982 140.05 47.3235 143.273L47.3265 143.257Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5174 114.066L61.1924 162.337H62.8182L61.5174 114.066Z",
    fill: "#263238"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0043 148.359C62.0043 148.359 65.2547 142.508 71.106 140.721C71.106 140.721 64.9303 142.183 61.8418 147.222L62.0043 148.359Z",
    fill: "#263238"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0043 131.782C62.0043 131.782 65.2547 125.931 71.106 124.143C71.106 124.143 64.9303 125.605 61.8418 130.643L62.0043 131.782Z",
    fill: "#263238"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0043 140.071C62.0043 140.071 65.2547 134.22 71.106 132.432C71.106 132.432 64.9303 133.894 61.8418 138.932L62.0043 140.071Z",
    fill: "#263238"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5231 136.007C61.5231 136.007 58.3869 130.156 52.7412 128.368C52.7412 128.368 58.7003 129.831 61.6804 134.87L61.5231 136.007Z",
    fill: "#263238"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5231 144.134C61.5231 144.134 58.3869 138.283 52.7412 136.495C52.7412 136.495 58.7003 137.958 61.6804 142.996L61.5231 144.134Z",
    fill: "#263238"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0854 148.832C86.0854 148.832 92.9014 149.507 96.3557 153.732C96.3557 153.732 100.006 148.837 106.561 148.937C108.463 146.645 109.607 143.7 109.608 140.488C109.611 133.171 103.681 127.238 96.365 127.235C89.0481 127.233 83.1146 133.162 83.1123 140.479C83.1111 143.65 84.2255 146.562 86.0831 148.843L86.0854 148.832Z",
    fill: "#FFA726"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M86.0854 148.832C86.0854 148.832 92.9014 149.507 96.3557 153.732C96.3557 153.732 100.006 148.837 106.561 148.937C108.463 146.645 109.607 143.7 109.608 140.488C109.611 133.171 103.681 127.238 96.365 127.235C89.0481 127.233 83.1146 133.162 83.1123 140.479C83.1111 143.65 84.2255 146.562 86.0831 148.843L86.0854 148.832Z",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1295 128.17L95.8994 162.338H97.0499L96.1295 128.17Z",
    fill: "#263238"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4751 152.444C96.4751 152.444 98.776 148.302 102.918 147.037C102.918 147.037 98.5459 148.072 96.3604 151.639L96.4751 152.444Z",
    fill: "#263238"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4751 140.71C96.4751 140.71 98.776 136.568 102.918 135.303C102.918 135.303 98.5459 136.338 96.3604 139.905L96.4751 140.71Z",
    fill: "#263238"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4751 146.577C96.4751 146.577 98.776 142.436 102.918 141.17C102.918 141.17 98.5459 142.205 96.3604 145.772L96.4751 146.577Z",
    fill: "#263238"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1335 143.701C96.1335 143.701 93.9136 139.559 89.917 138.294C89.917 138.294 94.1355 139.329 96.2442 142.896L96.1335 143.701Z",
    fill: "#263238"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1335 149.453C96.1335 149.453 93.9136 145.311 89.917 144.046C89.917 144.046 94.1355 145.082 96.2442 148.648L96.1335 149.453Z",
    fill: "#263238"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M176.991 161.935C185.375 159.98 190.586 151.599 188.631 143.216C186.676 134.832 178.295 129.621 169.911 131.575C161.528 133.53 156.316 141.912 158.271 150.295C160.226 158.679 168.607 163.89 176.991 161.935Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2996 157.758C81.3866 151.671 81.3866 141.802 75.2996 135.715C69.2126 129.628 59.3437 129.628 53.2568 135.715C47.1698 141.802 47.1698 151.671 53.2568 157.758C59.3437 163.845 69.2126 163.845 75.2996 157.758Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M162.941 117.199C162.941 117.199 158.801 114.612 139.916 108.403C121.03 102.194 108.872 100.124 90.2446 100.642C71.6177 101.159 46.5238 108.144 41.8672 109.955C37.2107 111.766 35.141 112.283 36.1755 113.577C37.2107 114.87 42.9018 119.527 42.1259 121.597C41.35 123.666 28.6734 135.049 27.8969 136.86C27.121 138.671 30.4838 144.88 31.0011 146.432C31.5184 147.984 34.3645 148.502 36.6928 148.76C39.0211 149.019 204.591 148.76 204.591 148.76C204.591 148.76 206.92 145.915 206.402 142.293C205.885 138.671 205.33 133.894 202.998 130.833C201.11 128.355 199.159 125.735 194.243 125.218C191.156 124.893 163.717 117.457 162.941 117.199Z",
    fill: "#0F538D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4836_11073",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 100,
    width: 180,
    height: 49
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M162.942 117.2C162.942 117.2 158.802 114.613 139.917 108.404C121.031 102.195 108.873 100.125 90.2456 100.642C71.6187 101.16 46.5248 108.145 41.8682 109.956C37.2116 111.767 35.142 112.284 36.1765 113.578C37.2116 114.871 42.9028 119.528 42.1268 121.598C41.3509 123.667 28.6744 135.05 27.8979 136.861C27.122 138.672 30.4848 144.881 31.0021 146.433C31.5194 147.985 34.3655 148.503 36.6938 148.761C39.0221 149.02 204.592 148.761 204.592 148.761C204.592 148.761 206.921 145.916 206.403 142.294C205.886 138.672 205.331 133.895 202.999 130.834C201.111 128.356 199.16 125.736 194.244 125.219C191.157 124.894 163.718 117.458 162.942 117.2Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4836_11073)"
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M162.942 117.2C162.942 117.2 158.802 114.613 139.917 108.404C121.031 102.195 108.873 100.125 90.2456 100.642C71.6187 101.16 46.5248 108.145 41.8682 109.956C37.2116 111.767 35.142 112.284 36.1765 113.578C37.2116 114.871 42.9028 119.528 42.1268 121.598C41.3509 123.667 28.6744 135.05 27.8979 136.861C27.122 138.672 30.4848 144.881 31.0021 146.433C31.5194 147.985 34.3655 148.503 36.6938 148.761C39.0221 149.02 204.592 148.761 204.592 148.761C204.592 148.761 206.921 145.916 206.403 142.294C205.886 138.672 205.331 133.895 202.999 130.834C201.111 128.356 199.16 125.736 194.244 125.219C191.157 124.894 163.718 117.458 162.942 117.2Z",
    fill: "#0F538D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4836_11073",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 100,
    width: 180,
    height: 49
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M162.943 117.201C162.943 117.201 158.803 114.614 139.918 108.405C121.032 102.196 108.874 100.126 90.2466 100.643C71.6197 101.161 46.5258 108.146 41.8692 109.957C37.2126 111.768 35.143 112.285 36.1775 113.579C37.2126 114.872 42.9037 119.529 42.1278 121.599C41.3519 123.668 28.6754 135.051 27.8989 136.862C27.123 138.673 30.4858 144.882 31.0031 146.434C31.5203 147.986 34.3665 148.504 36.6948 148.762C39.023 149.021 204.593 148.762 204.593 148.762C204.593 148.762 206.922 145.917 206.404 142.295C205.887 138.673 205.332 133.896 203 130.835C201.112 128.357 199.161 125.737 194.245 125.22C191.158 124.895 163.719 117.459 162.943 117.201Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4836_11073)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M162.943 117.201C162.943 117.201 158.803 114.614 139.918 108.405C121.032 102.196 108.874 100.126 90.2466 100.643C71.6197 101.161 46.5258 108.146 41.8692 109.957C37.2126 111.768 35.143 112.285 36.1775 113.579C37.2126 114.872 42.9037 119.529 42.1278 121.599C41.3519 123.668 28.6754 135.051 27.8989 136.862C27.123 138.673 30.4858 144.882 31.0031 146.434C31.5203 147.986 34.3665 148.504 36.6948 148.762C39.023 149.021 204.593 148.762 204.593 148.762C204.593 148.762 206.922 145.917 206.404 142.295C205.887 138.673 205.332 133.896 203 130.835C201.112 128.357 199.161 125.737 194.245 125.22C191.158 124.895 163.719 117.459 162.943 117.201Z",
    fill: "black"
  })))), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M162.941 117.199C162.941 117.199 158.801 114.612 139.916 108.403C121.03 102.194 108.872 100.124 90.2446 100.642C71.6177 101.159 46.5238 108.144 41.8672 109.955C37.2107 111.766 35.141 112.283 36.1755 113.577C37.2107 114.87 42.9018 119.527 42.1259 121.597C41.35 123.666 28.6734 135.049 27.8969 136.86C27.121 138.671 30.4838 144.88 31.0011 146.432C31.5184 147.984 34.3645 148.502 36.6928 148.76C39.0211 149.019 204.591 148.76 204.591 148.76C204.591 148.76 206.92 145.915 206.402 142.293C205.885 138.671 205.33 133.894 202.998 130.833C201.11 128.355 199.159 125.735 194.243 125.218C191.156 124.893 163.717 117.457 162.941 117.199Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M204.591 135.308H194.761V137.895H204.591V135.308Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M190.063 130.833H191.63C193.678 130.833 195.521 132.077 196.286 133.977L197.865 137.895H192.737L190.063 130.833Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M204.47 133.48C204.413 133.641 204.358 133.806 204.312 133.977L203.257 137.895H205.715C205.424 136.386 205.037 134.867 204.47 133.48Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M162.941 117.198C162.941 117.198 158.801 114.611 139.916 108.402C135.604 106.984 131.644 105.785 127.877 104.78H114.563L111.718 105.556L150.006 117.198L162.941 117.198Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M23.502 113.05V130.541C23.502 130.541 34.1427 121.796 32.8308 119.318C31.519 116.84 23.502 113.05 23.502 113.05Z",
    fill: "#8F8F8F",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M150.006 117.199C150.006 117.199 145.866 114.612 126.981 108.403C108.095 102.194 95.9364 100.124 77.3095 100.642C58.6826 101.159 33.5887 108.144 28.9321 109.955C24.2755 111.766 22.2058 112.283 23.2404 113.577C24.2749 114.87 29.9666 119.527 29.1907 121.597C28.4148 123.666 15.7382 135.049 14.9623 136.86C14.1864 138.671 17.5493 144.88 18.0665 146.432C18.5838 147.984 21.4299 148.502 23.7582 148.76C26.0865 149.019 191.657 148.76 191.657 148.76C191.657 148.76 193.985 145.915 193.468 142.293C192.95 138.671 192.396 133.894 190.064 130.833C188.176 128.355 186.224 125.735 181.308 125.218C178.221 124.893 150.781 117.457 150.006 117.199Z",
    fill: "#0F538D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4836_11073",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 100,
    width: 180,
    height: 49
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M150.006 117.199C150.006 117.199 145.867 114.612 126.982 108.403C108.096 102.194 95.9374 100.124 77.3105 100.642C58.6836 101.159 33.5896 108.144 28.9331 109.955C24.2765 111.766 22.2068 112.283 23.2414 113.577C24.2759 114.87 29.9676 119.527 29.1917 121.597C28.4158 123.666 15.7392 135.049 14.9633 136.86C14.1874 138.671 17.5502 144.88 18.0675 146.432C18.5848 147.984 21.4309 148.502 23.7592 148.76C26.0875 149.019 191.658 148.76 191.658 148.76C191.658 148.76 193.986 145.915 193.469 142.293C192.951 138.671 192.397 133.894 190.065 130.833C188.177 128.355 186.225 125.735 181.309 125.218C178.222 124.893 150.782 117.457 150.006 117.199Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4836_11073)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M190.065 130.833C188.177 128.355 186.225 125.735 181.309 125.218C180.493 125.132 177.973 124.549 174.696 123.733C159.062 123.573 150.348 129.897 126.994 132.037C96.5723 134.826 75.5303 127.221 50.1783 124.178C39.607 122.909 31.072 124.465 24.7029 126.706C20.7115 130.733 15.455 135.713 14.9633 136.859C14.1874 138.67 17.5502 144.879 18.0675 146.431C18.5848 147.983 21.4303 148.501 23.7592 148.759C26.0875 149.018 191.658 148.759 191.658 148.759C191.658 148.759 193.986 145.914 193.469 142.292C192.951 138.67 192.397 133.894 190.065 130.833Z",
    fill: "black"
  }))), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M150.006 117.199C150.006 117.199 145.866 114.612 126.981 108.403C108.095 102.194 95.9364 100.124 77.3095 100.642C58.6826 101.159 33.5887 108.144 28.9321 109.955C24.2755 111.766 22.2058 112.283 23.2404 113.577C24.2749 114.87 29.9666 119.527 29.1907 121.597C28.4148 123.666 15.7382 135.049 14.9623 136.86C14.1864 138.671 17.5493 144.88 18.0665 146.432C18.5838 147.984 21.4299 148.502 23.7582 148.76C26.0865 149.019 191.657 148.76 191.657 148.76C191.657 148.76 193.985 145.915 193.468 142.293C192.95 138.671 192.396 133.894 190.064 130.833C188.176 128.355 186.224 125.735 181.308 125.218C178.221 124.893 150.781 117.457 150.006 117.199Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1699 107.656L62.5194 118.589H138.609V116.111C138.609 116.111 123.012 109.989 106.54 106.782C90.0686 103.575 85.9875 103.866 78.5535 104.013C71.1195 104.158 52.1699 107.656 52.1699 107.656Z",
    fill: "#8F8F8F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_4836_11073",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 103,
    width: 87,
    height: 16
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1709 107.656L62.5203 118.589H138.609V116.111C138.609 116.111 123.013 109.989 106.541 106.782C90.0695 103.575 85.9885 103.866 78.5545 104.013C71.1205 104.158 52.1709 107.656 52.1709 107.656Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_4836_11073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.2686 113.808C76.2238 110.931 65.8354 113.865 60.2607 116.203L62.5191 118.589H138.608V116.111C138.608 116.111 136.083 115.121 131.994 113.728C123.436 117.001 106.465 117.601 89.2686 113.808Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  }))), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1699 107.656L62.5194 118.589H138.609V116.111C138.609 116.111 123.012 109.989 106.54 106.782C90.0686 103.575 85.9875 103.866 78.5535 104.013C71.1195 104.158 52.1699 107.656 52.1699 107.656Z",
    stroke: "#263238",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5703 120.047V143.806",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2121 161.927C58.5975 159.98 63.8167 151.604 61.8695 143.219C59.9222 134.833 51.546 129.614 43.1606 131.561C34.7752 133.508 29.5561 141.885 31.5033 150.27C33.4505 158.655 41.8267 163.875 50.2121 161.927Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6897 135.489C40.4772 135.489 35.4414 140.526 35.4414 146.738C35.4414 152.95 40.4772 157.986 46.6897 157.986C52.9021 157.986 57.9379 152.95 57.9379 146.738C57.9379 140.526 52.9021 135.489 46.6897 135.489ZM54.2466 144.486L47.6945 145.714L49.5539 139.391C51.8047 140.269 53.5516 142.15 54.2466 144.486ZM47.2541 146.174V147.302H46.1258V146.174H47.2541ZM44.4371 139.181L45.6656 145.733L39.3431 143.873C40.2215 141.623 42.1018 139.876 44.4371 139.181ZM39.1328 148.99L45.6848 147.762L43.8255 154.084C41.5746 153.206 39.8277 151.325 39.1328 148.99ZM48.9422 154.295L47.7137 147.743L54.0363 149.602C53.1579 151.853 51.2775 153.599 48.9422 154.295Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1771 146.737C50.1771 144.812 48.616 143.25 46.6896 143.25C44.7639 143.25 43.2021 144.811 43.2021 146.737C43.2021 148.663 44.7633 150.225 46.6896 150.225C48.6154 150.225 50.1771 148.664 50.1771 146.737Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M167.398 157.759C173.485 151.672 173.485 141.803 167.398 135.716C161.311 129.629 151.442 129.629 145.355 135.716C139.268 141.803 139.268 151.672 145.355 157.759C151.442 163.846 161.311 163.846 167.398 157.759Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M156.38 135.489C150.168 135.489 145.132 140.526 145.132 146.738C145.132 152.95 150.168 157.986 156.38 157.986C162.593 157.986 167.628 152.95 167.628 146.738C167.629 140.526 162.593 135.489 156.38 135.489ZM163.938 144.486L157.386 145.714L159.245 139.391C161.495 140.269 163.242 142.15 163.938 144.486ZM156.945 146.174V147.302H155.816V146.174H156.945ZM154.128 139.181L155.357 145.733L149.034 143.873C149.912 141.623 151.793 139.876 154.128 139.181ZM148.823 148.99L155.375 147.762L153.516 154.084C151.266 153.206 149.518 151.325 148.823 148.99ZM158.633 154.295L157.404 147.743L163.727 149.602C162.848 151.853 160.968 153.599 158.633 154.295Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M159.867 146.737C159.867 144.812 158.305 143.25 156.379 143.25C154.453 143.25 152.892 144.811 152.892 146.737C152.892 148.663 154.453 150.225 156.379 150.225C158.305 150.225 159.867 148.664 159.867 146.737Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M190.063 130.832C190.063 130.832 178.463 130.238 177.945 130.832C177.428 131.427 181.826 136.083 183.378 137.118C184.609 137.94 190.397 137.784 192.737 137.684C192.242 135.196 191.483 132.696 190.063 130.832Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4755 104.09C87.7153 104.039 86.9936 104.002 86.2963 103.978L84.3438 118.541H89.5176L88.4755 104.09Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M107.733 157.731C107.733 157.731 106.072 158.799 104.827 159.273C103.582 159.747 102.752 160.044 102.989 160.815C103.226 161.586 104.59 162.238 106.31 162.594C108.029 162.95 111.114 162.179 111.944 161.942C112.774 161.705 112.893 160.34 112.3 159.57C111.707 158.798 108.742 157.316 107.733 157.731Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M108.267 162.179C106.844 162.179 104.472 161.645 104.472 161.111C104.472 160.577 105.065 160.162 104.353 159.984C103.726 159.828 103.191 160.774 103.073 161.002C103.457 161.69 104.732 162.267 106.31 162.593C108.03 162.949 111.114 162.178 111.944 161.941C112.256 161.852 112.467 161.604 112.579 161.288C111.705 161.647 109.615 162.179 108.267 162.179Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M115.028 119.657L115.384 120.843C115.384 120.843 114.613 121.436 114.672 122.326C114.732 123.215 115.68 123.986 115.68 123.986",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M111.41 117.344C111.41 117.344 110.521 119.835 110.521 120.309C110.521 120.783 110.521 121.614 110.521 121.911C110.521 122.207 109.335 128.494 109.098 132.349C108.861 136.204 108.682 140.711 108.386 141.719C108.089 142.727 108.445 143.261 108.505 144.684C108.564 146.107 108.624 153.283 108.624 153.283C108.624 153.283 108.327 155.181 108.268 155.655C108.208 156.129 107.615 156.307 107.438 156.604C107.26 156.9 106.963 158.086 106.963 158.086C106.963 158.086 108.564 158.502 109.394 159.509C110.224 160.518 112.478 161.763 112.775 161.704C113.071 161.644 113.249 160.814 113.723 159.687C114.198 158.56 114.139 157.967 114.376 157.493C114.613 157.018 114.969 156.247 115.502 152.689C116.036 149.13 116.511 143.852 116.807 143.141C117.104 142.429 118.646 139.76 118.646 139.76C118.646 139.76 121.077 135.075 122.085 131.754C123.094 128.434 123.627 126.713 124.043 123.926C124.458 121.139 124.576 118.766 124.576 118.411C124.576 118.055 124.576 117.818 124.576 117.818C124.576 117.818 122.382 118.648 118.468 118.233C114.554 117.818 111.41 117.344 111.41 117.344Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M119.595 120.783C119.595 120.783 116.926 122.206 116.511 122.918C116.096 123.63 115.562 126.654 114.376 130.391C113.19 134.127 112.122 136.973 111.114 140.117C110.106 143.26 110.225 143.379 109.869 145.691C109.513 148.004 108.683 154.172 108.683 154.172",
    stroke: "#263238",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M112.537 160.636C112.537 160.636 113.842 160.161 113.842 157.492C113.842 154.823 113.368 152.926 113.842 150.376C114.317 147.826 115.503 143.674 116.214 142.429C116.925 141.183 117.756 139.582 117.756 139.582",
    stroke: "#263238",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M117.103 138.694C117.103 138.694 119.179 140.117 119.594 139.584C120.009 139.05 120.662 137.389 121.195 136.025C121.729 134.661 121.967 134.008 121.967 134.008C121.967 134.008 122.56 133.949 122.619 133.415C122.678 132.882 122.797 131.873 122.797 131.873C122.797 131.873 122.025 131.873 120.899 131.636C119.772 131.399 119.357 131.459 119.12 131.992C118.883 132.526 119.001 132.17 118.646 133.119C118.29 134.068 116.926 137.27 116.867 137.745C116.807 138.219 116.747 138.338 117.103 138.694Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M121.966 134.009C121.966 134.009 120.187 133.89 119.535 133.712C118.883 133.535 119.238 132.704 119.238 132.704",
    fill: "#C6FF00"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M121.966 134.009C121.966 134.009 120.187 133.89 119.535 133.712C118.883 133.535 119.238 132.704 119.238 132.704",
    stroke: "#263238",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M121.137 131.636C121.137 131.636 122.679 126.654 122.916 125.646C123.153 124.638 123.153 124.638 123.153 124.638",
    stroke: "#263238",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M121.611 119.419C121.611 119.419 121.196 121.494 121.611 122.622C122.027 123.748 123.45 124.935 123.687 125.053",
    stroke: "#263238",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M113.012 120.309C113.012 120.309 116.096 121.198 117.934 120.546",
    stroke: "#263238",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M118.646 97.002C118.646 97.002 114.613 98.0103 113.427 98.2474C112.241 98.4845 111.589 98.4845 111.41 99.0187C111.233 99.5522 108.267 104.416 106.903 105.898C105.539 107.381 105.42 108.804 105.835 109.575C106.25 110.346 106.725 110.701 108.504 110.227C110.283 109.753 111.41 108.27 111.41 108.27C111.41 108.27 111.825 112.718 111.232 114.497C110.639 116.276 110.402 117.7 110.817 117.996C111.232 118.293 113.426 119.419 116.688 119.538C119.95 119.657 123.686 119.36 124.279 118.767C124.872 118.174 124.872 117.818 124.872 117.403C124.872 116.987 124.635 114.2 125.346 112.006C126.057 109.811 128.074 104.177 128.134 102.042C128.193 99.9076 127.363 99.6111 125.762 98.9587C124.16 98.3063 121.61 97.1797 121.017 97.0609C120.425 96.9432 118.646 97.002 118.646 97.002Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M117.815 95.9358C117.815 95.9358 116.51 96.8253 116.451 97.0029C116.391 97.1812 114.316 100.502 114.553 100.502C114.79 100.502 117.4 99.1972 117.4 99.1972C117.4 99.1972 118.705 97.24 118.586 96.4694C118.467 95.6987 117.815 95.9358 117.815 95.9358Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M117.31 95.2784C117.31 95.2784 117.429 97.5916 117.013 99.1929C116.598 100.794 116.302 101.861 116.895 102.04C117.488 102.217 119.445 99.3117 119.978 98.4811C120.512 97.651 120.69 96.9392 120.69 96.9392L121.105 92.3135C121.105 92.3135 118.733 94.8637 117.31 95.2784Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M115.175 84.2476C115.175 84.2476 114.582 89.2887 114.582 91.1865C114.582 93.0843 115.827 95.5157 116.42 95.7528C117.013 95.9899 118.496 96.2269 119.089 95.8122C119.682 95.3969 121.343 92.8466 121.343 92.8466C121.343 92.8466 122.41 89.4069 122.588 87.3908C122.766 85.3742 122.232 84.4259 120.394 83.8323C118.555 83.2399 116.124 83.2399 115.175 84.2476Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M116.598 88.5762C116.598 88.5762 116.065 91.4823 116.302 91.5411C116.539 91.6006 117.37 91.6006 117.37 91.6006",
    stroke: "#263238",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M116.21 93.1288C116.21 93.1288 117.957 92.2548 119.123 93.1287",
    stroke: "#263238",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M118.791 88.6299C118.766 88.874 118.64 89.0615 118.51 89.0481C118.379 89.0347 118.294 88.8262 118.319 88.5815C118.344 88.3375 118.469 88.1499 118.6 88.1627C118.73 88.1767 118.816 88.3852 118.791 88.6299Z",
    fill: "#263238"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M116.3 88.3936C116.275 88.6376 116.15 88.8252 116.02 88.8118C115.889 88.7984 115.804 88.5899 115.829 88.3452C115.854 88.1006 115.979 87.9136 116.109 87.9264C116.24 87.9398 116.325 88.1489 116.3 88.3936Z",
    fill: "#263238"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M115.175 87.5083C115.175 87.5083 115.887 86.6782 116.598 87.4489",
    stroke: "#263238",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M117.725 87.39C117.725 87.39 118.851 86.5005 119.444 87.4494",
    stroke: "#263238",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M114.227 83.4173C114.227 83.4173 114.227 83.4727 114.247 83.5647C114.308 83.8402 114.553 84.4402 115.531 84.841C116.836 85.3746 119.92 84.7222 120.988 85.0781C122.055 85.434 121.581 86.4423 120.928 86.7982C120.276 87.1541 120.157 87.3318 120.454 87.7471C120.751 88.1624 121.462 88.5772 121.225 89.0519C120.988 89.5267 120.87 90.0008 121.285 90.0603C121.7 90.1197 121.997 90.1197 122.174 89.8826C122.352 89.6455 123.539 87.0953 123.539 85.6128C123.539 84.1303 122.827 83.4779 121.167 82.8255C119.506 82.1731 116.066 81.7578 115.058 82.3513C115.057 82.3502 114.404 82.5873 114.227 83.4173Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M121.106 92.1818C121.106 92.1818 121.639 92.7287 122.292 92.314C122.944 91.8987 123.241 90.4162 122.825 89.6449C122.41 88.8743 121.58 90.3568 121.58 90.3568",
    fill: "white"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M121.106 92.1818C121.106 92.1818 121.639 92.7287 122.292 92.314C122.944 91.8987 123.241 90.4162 122.825 89.6449C122.41 88.8743 121.58 90.3568 121.58 90.3568",
    stroke: "#263238",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M118.646 97.0027C118.646 97.0027 118.527 102.281 118.883 101.688C119.239 101.095 122.204 97.1809 122.204 97.1809L121.492 95.1055L118.646 97.0027Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M123.864 102.814L121.848 109.101L125.524 113.786C125.524 113.786 125.702 114.142 125.999 113.726C126.295 113.311 126.532 113.311 127.007 111.057C127.481 108.804 128.193 103.348 128.134 102.043C128.074 100.738 127.837 100.086 126.829 99.9082",
    fill: "#263238"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M123.864 102.814L121.848 109.101L125.524 113.786C125.524 113.786 125.702 114.142 125.999 113.726C126.295 113.311 126.532 113.311 127.007 111.057C127.481 108.804 128.193 103.348 128.134 102.043C128.074 100.738 127.837 100.086 126.829 99.9082",
    stroke: "#263238",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M112.597 110.109C112.597 110.109 121.789 113.608 123.035 113.667C124.28 113.727 124.577 112.896 124.043 111.354C123.509 109.812 121.908 108.923 120.544 108.507C119.18 108.092 117.164 108.211 115.799 108.567C114.436 108.923 112.597 109.635 112.597 110.109Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M120.247 108.449C120.247 108.449 122.441 113.193 122.56 113.608C122.679 114.023 124.932 114.32 125.644 114.26C126.356 114.201 126.059 113.134 125.348 111.591C124.636 110.049 123.509 108.685 122.679 108.448C121.848 108.211 120.247 108.449 120.247 108.449Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M107.97 106.789C107.97 106.789 106.547 106.908 105.717 107.263C104.887 107.619 104.708 110.11 105.124 110.999C105.539 111.889 106.844 111.889 107.733 111.829C108.623 111.77 109.038 111.177 109.038 111.177L109.691 106.788H107.97V106.789Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M109.691 106.789C109.691 106.789 116.393 106.789 118.053 106.729C119.713 106.67 120.128 107.085 120.484 107.678C120.84 108.271 120.958 108.508 120.958 108.508C120.958 108.508 117.519 108.805 114.791 109.873C112.063 110.94 109.69 111.889 108.86 111.889C108.03 111.889 107.674 109.754 108.03 108.272C108.386 106.789 109.691 106.789 109.691 106.789Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M107.793 106.373C107.793 106.373 110.639 106.314 110.58 106.848C110.52 107.381 109.987 111.414 109.809 111.77C109.631 112.126 107.911 112.304 107.081 112.244C106.251 112.185 106.547 109.516 107.081 108.271C107.614 107.025 107.793 106.373 107.793 106.373Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M116.273 119.895C116.273 119.895 116.748 120.606 116.57 120.784C116.392 120.962 115.502 121.792 115.561 122.326C115.621 122.859 115.917 123.156 115.917 123.156",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9083 182.986H70.3502L64.5581 174.188V182.986H62V170.147H64.5581L70.3502 178.963V170.147H72.9083V182.986Z",
    fill: "#0F538D"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9311 183.151C78.9566 183.151 78.0795 182.937 77.2999 182.508C76.5204 182.067 75.9052 181.449 75.4545 180.653C75.016 179.857 74.7967 178.939 74.7967 177.898C74.7967 176.857 75.0221 175.939 75.4728 175.143C75.9357 174.347 76.563 173.735 77.3548 173.306C78.1465 172.865 79.0297 172.645 80.0042 172.645C80.9787 172.645 81.8618 172.865 82.6536 173.306C83.4454 173.735 84.0666 174.347 84.5173 175.143C84.9802 175.939 85.2117 176.857 85.2117 177.898C85.2117 178.939 84.9741 179.857 84.4991 180.653C84.0362 181.449 83.4027 182.067 82.5988 182.508C81.807 182.937 80.9178 183.151 79.9311 183.151ZM79.9311 180.91C80.394 180.91 80.8264 180.8 81.2284 180.58C81.6426 180.347 81.9714 180.004 82.2151 179.551C82.4587 179.098 82.5805 178.547 82.5805 177.898C82.5805 176.931 82.3247 176.19 81.8131 175.676C81.3137 175.149 80.6985 174.886 79.9676 174.886C79.2368 174.886 78.6216 175.149 78.1222 175.676C77.6349 176.19 77.3913 176.931 77.3913 177.898C77.3913 178.865 77.6288 179.612 78.1039 180.139C78.5912 180.653 79.2002 180.91 79.9311 180.91Z",
    fill: "#0F538D"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8207 176.557C90.8207 175.296 91.1008 174.169 91.6612 173.178C92.2337 172.173 93.0072 171.396 93.9817 170.845C94.9684 170.282 96.0708 170 97.2889 170C98.7141 170 99.9627 170.367 101.035 171.102C102.107 171.837 102.856 172.853 103.282 174.151H100.34C100.048 173.539 99.6338 173.08 99.0978 172.773C98.574 172.467 97.965 172.314 97.2706 172.314C96.5276 172.314 95.8637 172.492 95.279 172.847C94.7065 173.19 94.2558 173.68 93.9269 174.316C93.6102 174.953 93.4518 175.7 93.4518 176.557C93.4518 177.402 93.6102 178.149 93.9269 178.798C94.2558 179.435 94.7065 179.931 95.279 180.286C95.8637 180.629 96.5276 180.8 97.2706 180.8C97.965 180.8 98.574 180.647 99.0978 180.341C99.6338 180.022 100.048 179.557 100.34 178.945H103.282C102.856 180.255 102.107 181.278 101.035 182.012C99.9749 182.735 98.7263 183.096 97.2889 183.096C96.0708 183.096 94.9684 182.82 93.9817 182.269C93.0072 181.706 92.2337 180.929 91.6612 179.937C91.1008 178.945 90.8207 177.818 90.8207 176.557Z",
    fill: "#0F538D"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M104.809 177.861C104.809 176.833 105.01 175.92 105.412 175.124C105.826 174.329 106.381 173.716 107.075 173.288C107.781 172.859 108.567 172.645 109.432 172.645C110.187 172.645 110.845 172.798 111.405 173.104C111.978 173.41 112.435 173.796 112.776 174.261V172.81H115.352V182.986H112.776V181.498C112.447 181.976 111.99 182.373 111.405 182.692C110.833 182.998 110.169 183.151 109.414 183.151C108.561 183.151 107.781 182.931 107.075 182.49C106.381 182.049 105.826 181.431 105.412 180.635C105.01 179.827 104.809 178.902 104.809 177.861ZM112.776 177.898C112.776 177.273 112.654 176.741 112.41 176.3C112.167 175.847 111.838 175.504 111.424 175.271C111.009 175.027 110.565 174.904 110.09 174.904C109.615 174.904 109.176 175.02 108.774 175.253C108.372 175.486 108.043 175.829 107.788 176.282C107.544 176.722 107.422 177.249 107.422 177.861C107.422 178.473 107.544 179.012 107.788 179.478C108.043 179.931 108.372 180.28 108.774 180.524C109.188 180.769 109.627 180.892 110.09 180.892C110.565 180.892 111.009 180.776 111.424 180.543C111.838 180.298 112.167 179.955 112.41 179.514C112.654 179.061 112.776 178.522 112.776 177.898Z",
    fill: "#0F538D"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M120.408 174.39C120.737 173.851 121.164 173.429 121.688 173.122C122.223 172.816 122.833 172.663 123.515 172.663V175.363H122.839C122.035 175.363 121.426 175.553 121.011 175.933C120.609 176.312 120.408 176.973 120.408 177.916V182.986H117.85V172.81H120.408V174.39Z",
    fill: "#0F538D"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M132.15 170.165V182.986H129.592V170.165H132.15Z",
    fill: "#0F538D"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M147.248 172.663C148.49 172.663 149.489 173.049 150.245 173.82C151.012 174.58 151.396 175.645 151.396 177.016V182.986H148.838V177.365C148.838 176.569 148.637 175.963 148.235 175.547C147.833 175.118 147.284 174.904 146.59 174.904C145.896 174.904 145.342 175.118 144.927 175.547C144.525 175.963 144.324 176.569 144.324 177.365V182.986H141.766V177.365C141.766 176.569 141.565 175.963 141.163 175.547C140.761 175.118 140.213 174.904 139.519 174.904C138.812 174.904 138.252 175.118 137.838 175.547C137.436 175.963 137.235 176.569 137.235 177.365V182.986H134.677V172.81H137.235V174.041C137.564 173.612 137.984 173.276 138.496 173.031C139.02 172.786 139.592 172.663 140.213 172.663C141.005 172.663 141.712 172.835 142.333 173.178C142.954 173.508 143.435 173.986 143.776 174.61C144.105 174.022 144.58 173.551 145.202 173.196C145.835 172.841 146.517 172.663 147.248 172.663Z",
    fill: "#0F538D"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M153.165 177.861C153.165 176.833 153.366 175.92 153.768 175.124C154.182 174.329 154.737 173.716 155.431 173.288C156.138 172.859 156.923 172.645 157.788 172.645C158.543 172.645 159.201 172.798 159.761 173.104C160.334 173.41 160.791 173.796 161.132 174.261V172.81H163.708V182.986H161.132V181.498C160.803 181.976 160.346 182.373 159.761 182.692C159.189 182.998 158.525 183.151 157.77 183.151C156.917 183.151 156.138 182.931 155.431 182.49C154.737 182.049 154.182 181.431 153.768 180.635C153.366 179.827 153.165 178.902 153.165 177.861ZM161.132 177.898C161.132 177.273 161.01 176.741 160.766 176.3C160.523 175.847 160.194 175.504 159.78 175.271C159.366 175.027 158.921 174.904 158.446 174.904C157.971 174.904 157.532 175.02 157.13 175.253C156.728 175.486 156.399 175.829 156.144 176.282C155.9 176.722 155.778 177.249 155.778 177.861C155.778 178.473 155.9 179.012 156.144 179.478C156.399 179.931 156.728 180.28 157.13 180.524C157.544 180.769 157.983 180.892 158.446 180.892C158.921 180.892 159.366 180.776 159.78 180.543C160.194 180.298 160.523 179.955 160.766 179.514C161.01 179.061 161.132 178.522 161.132 177.898Z",
    fill: "#0F538D"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M170.172 172.645C170.927 172.645 171.591 172.798 172.163 173.104C172.736 173.398 173.186 173.784 173.515 174.261V172.81H176.092V183.059C176.092 184.002 175.903 184.841 175.525 185.576C175.148 186.322 174.581 186.91 173.826 187.339C173.071 187.78 172.157 188 171.085 188C169.648 188 168.466 187.663 167.54 186.99C166.627 186.316 166.109 185.398 165.987 184.235H168.527C168.661 184.7 168.947 185.067 169.386 185.337C169.837 185.618 170.379 185.759 171.012 185.759C171.755 185.759 172.358 185.533 172.821 185.08C173.284 184.639 173.515 183.965 173.515 183.059V181.48C173.186 181.957 172.73 182.355 172.145 182.673C171.572 182.992 170.915 183.151 170.172 183.151C169.319 183.151 168.539 182.931 167.833 182.49C167.126 182.049 166.566 181.431 166.152 180.635C165.75 179.827 165.549 178.902 165.549 177.861C165.549 176.833 165.75 175.92 166.152 175.124C166.566 174.329 167.12 173.716 167.814 173.288C168.521 172.859 169.307 172.645 170.172 172.645ZM173.515 177.898C173.515 177.273 173.393 176.741 173.15 176.3C172.906 175.847 172.577 175.504 172.163 175.271C171.749 175.027 171.304 174.904 170.829 174.904C170.354 174.904 169.916 175.02 169.514 175.253C169.112 175.486 168.783 175.829 168.527 176.282C168.283 176.722 168.162 177.249 168.162 177.861C168.162 178.473 168.283 179.012 168.527 179.478C168.783 179.931 169.112 180.28 169.514 180.524C169.928 180.769 170.366 180.892 170.829 180.892C171.304 180.892 171.749 180.776 172.163 180.543C172.577 180.298 172.906 179.955 173.15 179.514C173.393 179.061 173.515 178.522 173.515 177.898Z",
    fill: "#0F538D"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M188 177.678C188 178.045 187.976 178.376 187.927 178.669H180.527C180.588 179.404 180.844 179.98 181.294 180.396C181.745 180.812 182.299 181.02 182.957 181.02C183.907 181.02 184.583 180.61 184.985 179.79H187.744C187.452 180.769 186.891 181.578 186.063 182.214C185.235 182.839 184.218 183.151 183.012 183.151C182.037 183.151 181.16 182.937 180.381 182.508C179.613 182.067 179.01 181.449 178.572 180.653C178.145 179.857 177.932 178.939 177.932 177.898C177.932 176.845 178.145 175.92 178.572 175.124C178.998 174.329 179.595 173.716 180.362 173.288C181.13 172.859 182.013 172.645 183.012 172.645C183.974 172.645 184.833 172.853 185.588 173.269C186.356 173.686 186.946 174.28 187.36 175.051C187.787 175.81 188 176.686 188 177.678ZM185.351 176.943C185.338 176.282 185.101 175.755 184.638 175.363C184.175 174.959 183.609 174.757 182.939 174.757C182.305 174.757 181.769 174.953 181.331 175.345C180.904 175.724 180.643 176.257 180.545 176.943H185.351Z",
    fill: "#0F538D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCarImg);
export default __webpack_public_path__ + "static/media/NoCarImg.e11d3f944b20059c9ba73afa98ffe204.svg";
export { ForwardRef as ReactComponent };